import { render } from "./ProjectCard.vue?vue&type=template&id=672838de&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=672838de&lang=scss&scoped=true"

import exportComponent from "/Users/amina/Desktop/streamup_amina/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672838de"]])

export default __exports__